import React from "react";
import { Icon, Button, notification } from "antd";
import moment from "moment";
import axios from "axios";
import { TIPOS_PLANO } from "../planos.constants";
import ModalLoading from "../../../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../../../shared/components/Modals/ModalViewer";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const PlanoIranduba = ({ onEdit, onEditPEI, onView, onViewPEI, plano }) => {
    const { id, tipo, apresentacao, dt_criado } = plano;

    const isPEI = tipo === "plano_atendimento_especializado_pei";

    const [modalVisible, setModalVisible] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [docs, setDocs] = React.useState([]);

    const dados = JSON.parse(apresentacao);

    const gerarPdf = () => {
        setIsLoading(true);
        axios({
            method: "get",
            url: "/api/pdf/formulario-plano-atendimento",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso"),
                planoId: id
            }
        })
            .then(response => {
                const { url, fileName } = response.data;
                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento.");
            })
            .finally(() => setIsLoading(false));
    };

    const gerarPdfPEI = () => {
        setIsLoading(true);
        axios({
            method: "get",
            url: "/api/pdf/formulario-plano-atendimento-pei",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso"),
                planoId: id
            }
        })
            .then(response => {
                const { url, fileName } = response.data;
                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento.");
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <>
            <div className="plano-atendimento-item">
                <div className="plano-atendimento-item-info">
                    <div>
                        <Icon type="file-text" />
                        {isPEI ? TIPOS_PLANO.plano_atendimento_especializado_pei : TIPOS_PLANO.plano_atendimento_especializado_paee}
                    </div>
                    <p>Data: {moment(dt_criado).format("DD/MM/YYYY")}</p>
                    {dados.aluno && <p>Estudante: {dados.aluno}</p>}
                </div>
                <div className="plano-atendimento-item-opcoes">
                    {isPEI ? (
                        <>
                            <Button onClick={() => onViewPEI(id)}>
                                <Icon type="eye" />
                                Visualizar
                            </Button>

                            <Button onClick={() => onEditPEI(id)}>
                                <Icon type="edit" />
                                Editar
                            </Button>

                            <Button onClick={gerarPdfPEI}>
                                <Icon type="download" />
                                PDF
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button onClick={() => onView(id)}>
                                <Icon type="eye" />
                                Visualizar
                            </Button>
                            <Button onClick={() => onEdit(id)}>
                                <Icon type="edit" />
                                Editar
                            </Button>
                            <Button onClick={gerarPdf}>
                                <Icon type="download" />
                                PDF
                            </Button>
                        </>
                    )}
                </div>
            </div>

            <ModalLoading visible={isLoading} text="A gerar documento..." />
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
        </>
    );
};

export default PlanoIranduba;
